import React from 'react';

import {Button} from '../../components/Button';
import {ArrowLong} from '../../assets';
import styles from './styles.module.scss';
import screen from '../../assets/img/screen.png';

export const Label = ({text, href, target}) => {
  return (
    <div className={styles.label}>
      <span>{text}</span>
      <Button icon={<ArrowLong />} href={href} target={target} />
    </div>
  );
};

export const LabelFeature = ({text, href, target}) => {
  return (
    <div className={styles.labelFeature}>
      <img src={screen} alt="screen" />
      <span>{text}</span>
      <Button icon={<ArrowLong />} href={href} target={target} />
    </div>
  );
};
